module.exports = __webpack_public_path__ + "img/bell-fill.25b4d5b2.svg";